import Base from './base';

export default {
  getList: async (productId: number, productItemId?: number): Promise<any> => (await Base()).get(`/products/${productId}/items/${productItemId || '0'}`),
};
